import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Examining the Story`}</h2>
    <p><img parentName="p" {...{
        "src": "./../images/demo/image.056.png",
        "alt": "image"
      }}></img>{`  `}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click the “hamburger menu” on the upper left. Click `}<strong parentName="p">{`Stories and alerts`}</strong>{` `}</p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.057.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`Now let’s have a look at the `}<strong parentName="p">{`Story`}</strong>{`.`}</p>
    <img {...{
      "src": "./../images/demo/image.059.png",
      "alt": "image"
    }}></img>
    <p>{`As I said before, the Story regroups all relevant information concerning the incident at hand that have been identified by CloudPak for AIOps.`}</p>
    <ol>
      <li parentName="ol">{`A list of Alerts that have been identified by CloudPak for AIOps to be the most probable cause`}</li>
      <li parentName="ol">{`The localization of the problem related to the Topology`}</li>
      <li parentName="ol">{`The suggested Runbooks to automatically mitigate the incident`}</li>
      <li parentName="ol">{`Similar Incidents that resemble the incident at hand`}</li>
      <li parentName="ol">{`Status of the Story - here I can change the status and priority of the story`}</li>
    </ol>
    <h2>{`📥 STEP: Acknowledge the Story`}</h2>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click on `}<strong parentName="p">{`Change Story Settings.`}</strong></p>
      <p parentName="blockquote">{`Select `}<strong parentName="p">{`Change Status.`}</strong></p>
      <p parentName="blockquote">{`Click on  `}<strong parentName="p">{`In progress`}</strong></p>
    </blockquote>
    <p><img parentName="p" {...{
        "src": "./../images/demo/image.079.png",
        "alt": "image"
      }}></img>{`  `}</p>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`First and before I continue examining the Story I want to let my colleagues know that I’m working on the incident. So let me set it to In Progress.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      